import { INITIAL_REDUX_STATE } from 'vio-constants';
const menusState = {
    customersInfoMenus: [],
    hamburgerMenu: false,
    locationsMenu: INITIAL_REDUX_STATE.MENUS.LOCATIONS_MENU,
    mapFibersMenu: INITIAL_REDUX_STATE.MENUS.MAP_FIBERS_MENU,
    mapOverlaysMenu: INITIAL_REDUX_STATE.MENUS.MAP_OVERLAYS_MENU,
    mapSettingsMenu: INITIAL_REDUX_STATE.MENUS.MAP_SETTINGS_MENU,
    networkingMenus: [],
    userMenu: INITIAL_REDUX_STATE.MENUS.USER_MENU,
    usersMenus: []
};
export default menusState;
